import { CheckIcon } from "@heroicons/react/24/solid";
import React, { useState } from "react";
import { useInView } from "react-intersection-observer";
import bgteal from "../Images/tealback.png";
import whyChooseUs from "../Images/work.png";

const WhyChooseUs = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const [chooseInView, setChooseInView] = useState(false);

  const { ref: chooseRef, inView } = useInView({
    threshold: 0.3, // Adjust the threshold according to when you want to trigger the animation
    onChange: (inView) => {
      setChooseInView(inView);
    },
  });

  const handleToggle = (index) => {
    // Toggle the currently clicked section, collapse if already open or open the new one
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div
      className="lg:h-screen md:h-screen   px-1 md:px-10 lg:px-32  bg-gradient-to-br from-teal-950 via-teal-900 to-teal-700"
      style={{
        backgroundImage: `url(${bgteal})`,
        backgroundSize: "cover",
        backgroundPosition: "top left",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed", // Fix background movement
      }}
    >
      <div className="lg:h-screen md:h-screen  flex flex-col items-center justify-center sm:flex-col md:flex-row lg:flex-row gap-8 px-6 md:px-20 py-12 ">
        {/* Left Div */}
        <div className="flex-1 md:w-1/2 lg:w-1/2 lg:px-16 md:px-0 px-2 ">
          <h2 className="text-2xl md:text-3xl lg:text-4xl text-center md:text-left text-white font-semibold mb-2">
            Why Choose Us
          </h2>
          <p className="text-center  md:text-left text-white text-sm md:text-md lg:text-lg  py-4">
            At Solvexa Marketing, we blend creativity with strategy to deliver
            exceptional results.
          </p>
          <div>
            {[
              {
                title: "Results-Driven",
                description:
                  "Our focus is on delivering measurable outcomes that drive growth and engagement.",
              },
              {
                title: "Innovative Solutions",
                description:
                  "We offer cutting-edge marketing strategies that keep your brand ahead of the curve.",
              },
              {
                title: "Tailored Approach",
                description:
                  "We customize our services to meet your unique needs and objectives for maximum impact.",
              },
            ].map((point, index) => (
              <div
                key={index}
                className={`${
                  index === openIndex ? "border-teal-600" : "border"
                } mb-4 border rounded-lg hover:border hover:border-teal-100 py-4 transition-all duration-500 ease-in-out`}
              >
                <button
                  onClick={() => handleToggle(index)}
                  className="w-full text-left px-4 py-2 text-white font-semibold rounded-t-lg flex items-center space-x-3 focus:outline-none"
                >
                  <CheckIcon className="h-6 w-6" />
                  <span className="ml-2 text-sm md:text-md lg:text-lg">
                    {point.title}
                  </span>
                </button>
                {openIndex === index && (
                  <div
                    className="px-10 overflow-hidden transition-all duration-500 ease-in-out"
                    style={{
                      maxHeight: openIndex === index ? "200px" : "0px",
                      opacity: openIndex === index ? 1 : 0,
                    }}
                  >
                    <p className="text-white text-sm md:text-md lg:text-lg">
                      {point.description}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
        <div className=" w-full md:w-1/2  justify-center md:justify-end  hidden md:block">
          <img
            src={whyChooseUs}
            alt="Why Choose Us"
            ref={chooseRef}
            className={`    duration-500 ease-out ${
              chooseInView ? "scale-75  opacity-100" : "opacity-75 scale-50"
            }`}
          />
        </div>
      </div>
    </div>
  );
};

export default WhyChooseUs;
